import React from "react";
import { Input, InputParentGroup } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans from "../../../utils";

export default function DriverInfo({ addData }) {
	return (
		<div className="driverinfo mb-24">
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Name")}
						type="text"
						placeholder={trans("Ex. Ahmed Ali")}
						formstyle="form-input"
						id="name"
						name="name"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.name}
						touched={addData.touched.name}
						value={addData.values.name || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Code")}
						type="text"
						placeholder={trans("Ex. 123AB")}
						formstyle="form-input"
						id="code"
						name="code"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.code}
						touched={addData.touched.code}
						value={addData.values.code || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Address")}
						type="text"
						placeholder={trans("EX. Riydah - SaudiArabia")}
						formstyle="form-input"
						id="address"
						name="address"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.address}
						touched={addData.touched.address}
						value={addData.values.address || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("ID number")}
						type="text"
						placeholder={trans("EX. A12345678910")}
						formstyle="form-input"
						id="idNo"
						name="idNo"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.idNo}
						touched={addData.touched.idNo}
						value={addData.values.idNo || ""}
					/>
				</div>
				<div className="col-lg-6">
					<div
						className={`position-relative form-input ${
							addData.touched.phoneNumber &&
							addData.errors.phoneNumber &&
							"form-error"
						}`}
					>
						<label className="form-label text-capitalize">
							{trans("phone number")}
						</label>
						<div dir="ltr">
							<PhoneInput
								country={"eg"}
								id="phoneNumber"
								name="phoneNumber"
								onBlur={addData.handleBlur}
								onChange={(value) =>
									addData.setFieldValue("phoneNumber", value)
								}
								value={addData.values.phoneNumber || ""}
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
							/>
						</div>
						{addData.touched.phoneNumber && addData.errors.phoneNumber ? (
							<div className="validation">
								{trans(addData.errors.phoneNumber)}
							</div>
						) : null}
					</div>
				</div>
				<div className="col-lg-6">
					<div
						className={`position-relative form-input ${
							addData.touched.emergencyPhoneNumber &&
							addData.errors.emergencyPhoneNumber &&
							"form-error"
						}`}
					>
						<label className="form-label">{trans("Emergency Number")}</label>
						<div dir="ltr">
							<PhoneInput
								country={"eg"}
								id="emergencyPhoneNumber"
								name="emergencyPhoneNumber"
								onBlur={addData.handleBlur}
								onChange={(value) =>
									addData.setFieldValue("emergencyPhoneNumber", value)
								}
								value={addData.values.emergencyPhoneNumber || ""}
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
							/>
						</div>
						{addData.touched.emergencyPhoneNumber &&
						addData.errors.emergencyPhoneNumber ? (
							<div className="validation">
								{trans(addData.errors.emergencyPhoneNumber)}
							</div>
						) : null}
					</div>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("license number")}
						type="text"
						placeholder={"abc - 123"}
						id="licenseNo"
						name="licenseNo"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						value={addData.values.licenseNo || ""}
					/>
				</div>
				{/* <div className="col-lg-6">
					<InputParentGroup
						id="parent"
						name="parent"
						title={trans("parent")}
						formstyle="form-input"
						onBlur={(value) => addData.setFieldTouched("parent", true)}
						onChange={(value) => addData.setFieldValue("parent", value)}
						errors={addData.errors.parent}
						touched={addData.touched.parent}
						value={addData.values.parent || ""}
					/>
				</div> */}
			</div>
		</div>
	);
}
